<mat-toolbar>
  <div class="left-cont">
    <h1 class="brand" (click)="showVersion()" l10nTranslate>admin.appName</h1>
  </div>
  <div class="topbar-actions">
    <ng-container *ngIf="isDigitalAssistantUser$ | async">
      <miq-digital-assistant-button [userInfo]="userInformation">
        <mat-icon chatOpen class="chat-bot-icon" svgIcon="expand-more"></mat-icon>
      </miq-digital-assistant-button>
    </ng-container>
    <div class="howToVideos">
      <a
        id="e2e-how-to-videos"
        class="item-howToVideos-link"
        matTooltipClass="tooltip-action-icon__how-to-videos"
        target="_blank"
        rel="noopener noreferrer"
        [matTooltip]="howToVideosText"
        [href]="howToVideosURL"
      >
        <mat-icon class="howToVideos-icon" svgIcon="howToVideos-icon"></mat-icon>
      </a>
    </div>

    <div class="clipboard-dd">
      <button id="e2e-clipboard" [matMenuTriggerFor]="clipboardMenu">
        <mat-icon svgIcon="clipboard-icon"></mat-icon>
        <span class="clipboard-total">{{ totalClipboardItems }}</span>
      </button>
    </div>
    <mat-menu class="clipboard-menu" #clipboardMenu="matMenu">
      <ul class="clipboard-dd-content">
        <li
          *ngFor="let entity of entities$ | async; let i = index"
          (click)="onClipboardClick(entity.key.toLowerCase())"
          class="e2e-clipbrd-{{ i }}"
        >
          <span>{{ 'user.' + entity.key.toLowerCase() | xTranslate | uppercase }}</span
          ><span> ({{ entity.value }})</span>
          <mat-icon (click)="onClearEntity(entity.key)" (click)="$event.stopPropagation()">close</mat-icon>
        </li>
        <li (click)="clearAll(); $event.stopPropagation()" l10nTranslate>
          core.clearAll
          <!-- ( This may be requested to be put back in: mat-icon svgIcon="close-icon"></mat-icon -->
        </li>
      </ul>
    </mat-menu>

    <div class="user-profile">
      <button id="e2e-user-profile" mat-flat-button class="menu" [matMenuTriggerFor]="profileMenu">
        <span class="circle-icon">{{ userName | usernameInitials: 2 }}</span>
        <mat-icon class="caret">arrow_drop_down</mat-icon>
      </button>
      <mat-menu class="my-profile-menu" #profileMenu="matMenu">
        <button mat-menu-item i18n (click)="openLinkInNewTab('/profile')" l10nTranslate>admin.myprofile</button>
        <button mat-menu-item i18n [matMenuTriggerFor]="roleMenu" l10nTranslate *ngIf="isAdmin">
          admin.role <span class="info-text">{{ userInformation?.roleVal }}</span>
        </button>

        <mat-menu #roleMenu="matMenu">
          <ng-container *ngFor="let role of roles">
            <button
              mat-menu-item
              i18n
              class="submenu"
              [ngClass]="{ activeLang: userInformation?.roleVal === role?.value }"
              (click)="updateUserType('role', role.key)"
            >
              {{ role.name }}
            </button>
          </ng-container>
        </mat-menu>
        <button mat-menu-item i18n [matMenuTriggerFor]="catalogLOBMenu" l10nTranslate *ngIf="isAdmin">
          admin.catalogLob <span class="info-text">{{ userInformation?.userLob }}</span>
        </button>

        <mat-menu #catalogLOBMenu="matMenu">
          <ng-container *ngFor="let lob of countryLobData">
            <button
              mat-menu-item
              i18n
              class="submenu"
              [ngClass]="{ activeLang: userInformation?.userLob === lob?.value }"
              (click)="updateUserType('lob', lob.key)"
            >
              {{ lob.value }}
            </button>
          </ng-container>
        </mat-menu>
        <button mat-menu-item i18n [matMenuTriggerFor]="groupMenu" l10nTranslate *ngIf="isAdmin">admin.group</button>
        <mat-menu #groupMenu="matMenu">
          <miq-multiselect-groups
            [userGroupOptions]="groupsData | filterUserGroups: userInformation?.userLobSkey"
            [userListedGroups]="userInformation?.groups"
            (saveGroupsEvent)="updateUserGroups($event)"
            (closeMenuEvent)="groupMenu.closed.next()"
          >
          </miq-multiselect-groups>
        </mat-menu>
        <button mat-menu-item i18n [matMenuTriggerFor]="languageMenu" l10nTranslate>core.language</button>
        <button mat-menu-item i18n l10nTranslate (click)="logOut()">admin.logOut</button>
        <mat-menu #languageMenu="matMenu">
          <ng-container *ngFor="let language of languages$ | async">
            <button
              mat-menu-item
              i18n
              class="submenu"
              [disabled]="language.defaultLanguage"
              [ngClass]="language.defaultLanguage ? 'activeLang' : ''"
              (click)="setDefaultLang(language.localeKey)"
            >
              <mat-icon class="flagicon" [svgIcon]="language.countryFlagKey"></mat-icon>
              {{ language.languageDesc }}
            </button>
          </ng-container>
        </mat-menu>
      </mat-menu>
    </div>
  </div>
</mat-toolbar>
